var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset';
export var StyledContent = styled(Inset)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  // Make content fill remaining height\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n"], ["\n  // Make content fill remaining height\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n"])));
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map